import React from "react";
import { Dalle } from "../base/Dalle";
import { MISSION_CONFIG } from "./missionConfig";

export default function MissionDalle(props) {
  return (
    <Dalle
      {...props}
      workshopConfig={MISSION_CONFIG.dalle}
      storageKey={MISSION_CONFIG.storageKeys.dalleOutputs}
    />
  );
}
